import React, { useEffect, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { useTranslation } from "react-i18next"
import { makeStyles, useTheme } from "@material-ui/core/styles"
import Button from "@material-ui/core/Button"
import Menu from "@material-ui/core/Menu"
import MenuItem from "@material-ui/core/MenuItem"
import { Divider, Grid, IconButton, Box } from "@material-ui/core"
import { useHistory } from "react-router-dom"
import Tags from "./additionalDetails/Tags"
import DetailView from "./additionalDetails/DetailView"
import { getFileRowClickRequest, getFileRequestByPage } from "../../actions/documentModalActions"
import { updateViewerPageNumber } from "../../actions/viewerActions"
import { updateFileTagReset } from "../../actions/documentsActions"
import ViewerReview from "./ViewerReview"
import ViewerTaggedDate from "../taggedDate/ViewerTaggedDate"
import TaggedDateDialog from "../common/dialog/TaggedDateDialog"
import { updateTaggedDateReset } from "../../actions/taggedDateActions"

const useStyles = makeStyles((theme) => ({
	root: {
		...theme.typography.body1,
		backgroundColor: theme.palette.common.white,
		border: `solid 1px ${theme.palette.grey.D400}`,
		borderRadius: "5px",
		marginBottom: "20px",
		height: `calc(70vh + 84px)`,
		overflow: "auto",
	},
}))

const ViewerAdditionalDetails = (props) => {
	const classes = useStyles()
	const dispatch = useDispatch()
	const history = useHistory()
	const theme = useTheme()
	const [t] = useTranslation("global")

	const { documentDetails, currentDocument } = useSelector((state) => state.documentModal)
	const { tags } = useSelector((state) => state.viewerData)
	const { reviewBasedOnFileId } = useSelector((state) => state.review)
	const { isApplyTagLoading, isApplyTagSuccess } = useSelector((state) => state.search)
	const [taggedDateDialogOpen, setTaggedDateDialogOpen] = useState(false)
	const [tagDatedDialogData, setTagDatedDialogData] = useState({})
	const isTaggedDateUpdated = useSelector((state) => state.taggedDateReducers?.isTaggedDateUpdated)

	const { currentPageNumber } = useSelector((state) => state.viewerData)

	const { id, job_id } = useSelector((state) => state?.review?.review)

	const renderTaggedDate = (data) => {
		return <ViewerTaggedDate data={data} dialogData={{ taggedDateDialogOpen, setTaggedDateDialogOpen, setTagDatedDialogData }} />
	}

	useEffect(() => {
		if (isApplyTagSuccess) {
			dispatch(
				getFileRequestByPage({
					id: documentDetails?.file_id,
					page: currentPageNumber || 1,
					reviewId: props?.retainedFilterJobData?.additional_params?.review_id,
				})
			)
			dispatch(updateViewerPageNumber(currentPageNumber || 1))
		}
	}, [isApplyTagSuccess])

	useEffect(() => {
		dispatch(updateFileTagReset())
	}, [])

	useEffect(() => {
		dispatch(updateTaggedDateReset())
	}, [isTaggedDateUpdated])

	return (
		<>
			<Box className={classes.root}>
				{props?.retainedFilterJobData?.additional_params?.review_id && reviewBasedOnFileId?.length > 0 && (
					<ViewerReview retainedFilterJobData={props?.retainedFilterJobData} />
				)}
				<Tags tags={tags} details={documentDetails} retainedFilterJobData={props?.retainedFilterJobData} />
				<DetailView retainedFilterJobData={props?.retainedFilterJobData} renderTaggedDate={renderTaggedDate} />
			</Box>
			<TaggedDateDialog
				open={taggedDateDialogOpen}
				title={t("taggedDateDialog.title")}
				onClose={() => {
					setTaggedDateDialogOpen(false)
				}}
				tagDatedDialogData={tagDatedDialogData}
			/>
		</>
	)
}

export default ViewerAdditionalDetails
